TECL_ProductSlider = {
    assistedScrolling: !1,
    Initialise: function(o) {
        scrollTimer = "";
        resizeTimer = "";

        scrollPos = 0;
        if( $(o).length > 0 ) {

            $(document).ready(function() {
                TECL_ProductSlider.SpaceProducts(o);
                TECL_ProductSlider.DisableControlAtEnd(o);
            });

            $(window).on("load", function() {
              var maxHeight = 0;

              $(o).each(function(){
                $(this).children().each(function(){
                   var thisHeight = $(this).outerHeight(true);
                   if (thisHeight > maxHeight) {
                     maxHeight = thisHeight;
                   }
                });

                $(this).height(maxHeight + 30);
                $(this).parent().height(maxHeight);
              });
            });

            $(window).resize(function() {
                TECL_ProductSlider.SpaceProducts(o);
                if(resizeTimer != -1) {
                    clearTimeout(resizeTimer);
                }

                resizeTimer = setTimeout(function() {
                    if ( TECL_ProductSlider.assistedScrolling == false ) {
                        TECL_ProductSlider.ScrollToNearestProduct($(o), false, false);
                    }
                }, 100);
            });

            $(o).on("scroll", function() {
                currentScrollPos = $(o).scrollLeft();

                if(currentScrollPos > scrollPos) {
                    scrollingLeft = false;
                } else {
                    scrollingLeft = true;
                }

                scrollPos = currentScrollPos;
                TECL_ProductSlider.Scrolling($(this), scrollingLeft);
            });

            $(".control-previous, .control-next").on("mousedown", function() {
                TECL_ProductSlider.MouseDown($(this));
            }).on("mouseup", function() {
                TECL_ProductSlider.MouseUp($(this));
            });
        }
    },
    SpaceProducts: function(o) {
        totalWidth = $(".products").outerWidth();
        productWidth = $(".product:first-child").outerWidth();
        productPadding = 10;

        productsInView = Math.floor(totalWidth / (productWidth + productPadding));
        productsWidth = productWidth * productsInView;
        spaceRemaining = totalWidth - productsWidth;
        numSpacesBetweenProducts = 2 * productsInView;
        newMarginSize = Math.floor((spaceRemaining / numSpacesBetweenProducts));
        o.children().css("margin-left", newMarginSize + "px");
        o.children().css("margin-right", newMarginSize + "px");
    },
    ScrollBackwards: function(o) {
        if( $(o).hasClass("control-previous") ) {
            scrollBackwards = true;
        } else {
            scrollBackwards = false;
        }

        return scrollBackwards;
    },
    TargetProducts: function(o) {
        targetProducts = $(o).attr("data-scroll");
        if ( typeof targetProducts == 'undefined' ) {
            console.log("Warning: TECL_ProductSlider missing data-scroll attribute");
            targetProducts = $(".product-line");
        } else {
            targetProducts = $(targetProducts).children(".product-line");
        }

        return targetProducts
    },
    MouseDown: function(o) {
        scrollBackwards = TECL_ProductSlider.ScrollBackwards(o);
        targetProducts = TECL_ProductSlider.TargetProducts(o);
        TECL_ProductSlider.assistedScrolling =  true;

        mouseDownSecs = 0;

        scrollOrClick = setInterval(function() {
            mouseDownSecs++
        }, 100);

        scrollInterval = setInterval(function() {
            TECL_ProductSlider.Scroll($(targetProducts), mouseDownSecs, scrollBackwards)
        }, 5);
    },
    MouseUp: function(o) {
        scrollBackwards = TECL_ProductSlider.ScrollBackwards(o);
        targetProducts = TECL_ProductSlider.TargetProducts(o);
        productWidth = $(".product:first-child").outerWidth(true);
        productMarginWidth = 0;
        multipleCount = 1;
        scrollPos = $(targetProducts).scrollLeft();
        newPos = 0;

        if(mouseDownSecs <= 3) {
            multipleCount = scrollPos / productWidth >> 0;

            if(scrollBackwards == true) {
                newScrollLeft = (multipleCount - 1) * productWidth;
            } else {
                newScrollLeft = (multipleCount + 1) * productWidth;
            }

            $(targetProducts).animate({ scrollLeft: newScrollLeft }, 300, function(){
                TECL_ProductSlider.assistedScrolling = false;
            });
        } else {
            if(scrollBackwards == true) {
               TECL_ProductSlider.ScrollToNearestProduct($(targetProducts), true, true);
            } else {
               TECL_ProductSlider.ScrollToNearestProduct($(targetProducts), false, true);
            }
        }

        clearInterval(scrollInterval);
        clearInterval(scrollOrClick);
    },
    Scrolling: function(o, t) {
        if( scrollTimer != -1 ) {
            clearTimeout(scrollTimer)
        }

        TECL_ProductSlider.DisableControlAtEnd(o);

        scrollTimer = setTimeout(function() {
            if( !TECL_ProductSlider.assistedScrolling ) {
                TECL_ProductSlider.ScrollToNearestProduct($(o), t, false);
            }
        }, 100)
    },
    Scroll: function(o, t, r) {
        TECL_ProductSlider.assistedScrolling = true;
        if ( t >= 3 & t < 20 ) {
            if ( r == true ) {
                o.scrollLeft(o.scrollLeft() - 3);
            } else {
                o.scrollLeft(o.scrollLeft() + 3);
            }
        } else if ( t >= 20 & t < 40 ) {
            if ( r == true ) {
                $(o).scrollLeft(o.scrollLeft() - 6);
            } else {
                $(o).scrollLeft(o.scrollLeft() + 6);
            }
        } else if ( t >= 40 ) {
            if ( r == true ) {
                $(o).scrollLeft(o.scrollLeft() - 9);
            } else {
                $(o).scrollLeft(o.scrollLeft() + 9);
            }
        }
    },
    ScrollToNearestProduct: function(o, scrollBackwards, withInertia) {
        TECL_ProductSlider.assistedScrolling = true;
        newScrollLeft = 0;
        multipleCount = 0;
        scrollPos = $(o).scrollLeft();
        productWidth = $(".product:first-child").outerWidth(true);

        multipleCount = Math.ceil(scrollPos / productWidth);
        inertiaBuffer = 0;



        if(withInertia == true) {
            if(!scrollBackwards == true) {
                inertiaBuffer = 1;
            }
        }

        newScrollLeft = (multipleCount + inertiaBuffer) * productWidth;

        $(o).animate({ scrollLeft: newScrollLeft }, 300, function() {
            setTimeout(function() {
                TECL_ProductSlider.assistedScrolling = false;
                TECL_ProductSlider.DisableControlAtEnd(o);
            }, 500)
        })
    },
    DisableControlAtEnd: function(o) {
      $(o).each(function(){
        scrollPos = o.scrollLeft();
        scrollWidth = this.scrollWidth;
        totalWidth = $(this).parent().width();
        scrollRemaining = scrollWidth - scrollPos - totalWidth;

        if(scrollRemaining < 10) {
            $(this).parent().parent().find(".control-next").addClass("disabled");
        } else {
            $(this).parent().parent().find(".control-next").removeClass("disabled");
        }

        if(scrollPos < 10) {
            $(this).parent().parent().find(".control-previous").addClass("disabled");
        } else {
            $(this).parent().parent().find(".control-previous").removeClass("disabled");
        }
      });
    }
};
